module.exports = __webpack_public_path__ + "img/iconmonstr-instagram-11.341a67c5.svg";